import * as types from '../actionTypes'

const initialState = null

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USER_PROFILE_SUCCESS: {
      return action.payload
    }
    default:
      return state
  }
}